const INP = {
  width: '100%', padding: '10px 13px', borderRadius: 5,
  background: 'rgba(255,255,255,.05)', border: '1px solid rgba(201,168,76,.18)',
  color: '#fff', fontSize: '.84rem', fontFamily: 'var(--sans)',
  outline: 'none', boxSizing: 'border-box',
};
const LBL = {
  fontSize: '.6rem', color: 'rgba(255,255,255,.36)',
  letterSpacing: '.1em', textTransform: 'uppercase', marginBottom: 5, display: 'block',
};

const CITIES = [
  'New Cairo', 'Sheikh Zayed', 'October City', 'North Coast',
  'Ain Sokhna', 'Maadi', 'Zamalek', 'Heliopolis', 'Alexandria',
  'Hurghada', 'Sharm El Sheikh', 'New Administrative Capital',
];

export default function Step2Location({ form, update, errors }) {
  const sectionHead = {
    color: 'rgba(255,255,255,.85)', fontSize: '.82rem', fontWeight: 700,
    marginBottom: '1rem', marginTop: '.5rem',
    paddingBottom: '.5rem', borderBottom: '1px solid rgba(201,168,76,.1)',
    display: 'flex', alignItems: 'center', gap: 7,
  };

  return (
    <div>
      <div style={sectionHead}>
        <span style={{ color: 'var(--gold)' }}>②</span> Location & Geography
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '.85rem 1rem', marginBottom: '1rem' }}>
        {/* City */}
        <div>
          <label style={LBL}>City / Region *</label>
          <input
            id="step2-city"
            name="city"
            style={{ ...INP, borderColor: errors.city ? 'rgba(248,113,113,.5)' : 'rgba(201,168,76,.18)' }}
            list="city-list"
            value={form.city}
            onChange={e => update({ city: e.target.value })}
            placeholder="e.g. New Cairo"
          />
          <datalist id="city-list">
            {CITIES.map(c => <option key={c} value={c} />)}
          </datalist>
          {errors.city && (
            <div style={{ color: '#f87171', fontSize: '.7rem', marginTop: 3 }}>{errors.city}</div>
          )}
        </div>

        {/* District */}
        <div>
          <label style={LBL}>Specific Area / District</label>
          <input
            id="step2-district"
            name="district"
            style={INP}
            value={form.district}
            onChange={e => update({ district: e.target.value })}
            placeholder="e.g. Fifth Settlement"
          />
        </div>

        {/* Latitude */}
        <div>
          <label style={LBL}>Latitude</label>
          <input
            id="step2-latitude"
            name="latitude"
            style={INP}
            type="number"
            step="any"
            value={form.latitude}
            onChange={e => update({ latitude: e.target.value })}
            placeholder="30.0444"
          />
        </div>

        {/* Longitude */}
        <div>
          <label style={LBL}>Longitude</label>
          <input
            id="step2-longitude"
            name="longitude"
            style={INP}
            type="number"
            step="any"
            value={form.longitude}
            onChange={e => update({ longitude: e.target.value })}
            placeholder="31.2357"
          />
        </div>
      </div>

      {/* Map Embed URL */}
      <div>
        <label style={LBL}>Google Maps Embed URL</label>
        <input
          id="step2-map-embed-url"
          name="mapEmbedUrl"
          style={INP}
          value={form.mapEmbedUrl}
          onChange={e => update({ mapEmbedUrl: e.target.value })}
          placeholder="https://www.google.com/maps/embed?pb=..."
        />
      </div>

      {/* Preview */}
      {form.mapEmbedUrl && (
        <div style={{ marginTop: 12, borderRadius: 7, overflow: 'hidden', border: '1px solid rgba(201,168,76,.15)', height: 180 }}>
          <iframe
            src={form.mapEmbedUrl}
            width="100%"
            height="180"
            style={{ border: 0, display: 'block' }}
            allowFullScreen
            loading="lazy"
            title="Map Preview"
          />
        </div>
      )}

      {(form.latitude || form.longitude) && !form.mapEmbedUrl && (
        <div style={{
          marginTop: 10, padding: '8px 12px',
          background: 'rgba(201,168,76,.06)', border: '1px solid rgba(201,168,76,.15)',
          borderRadius: 5, fontSize: '.74rem', color: 'rgba(255,255,255,.5)',
        }}>
          📍 Coordinates set: {form.latitude}, {form.longitude}
        </div>
      )}
    </div>
  );
}
